'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var core = require('@material-ui/core');

var StyledIconButton = styled__default(core.IconButton)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  padding: 0.25rem;\n  svg {\n    height: 18px;\n    width: 18px;\n  }\n"], ["\n  padding: 0.25rem;\n  svg {\n    height: 18px;\n    width: 18px;\n  }\n"])));
var templateObject_1;

exports.StyledIconButton = StyledIconButton;
